export const CookieName = "placement_platform_admin_security";
